export const defaultName = "Hoi Kong Campaign";
export const CART_STORAGE_KEY = 'campaign_cart';
